export default "__VITE_ASSET__BcQe2MvE__"